import { Height } from '@material-ui/icons';
import React from 'react';

const Navigate = () => {

   const NavigateBtn = {
      position: 'absolute',
      top: '44px',
      right: '-6px',

      flexDirection: 'column',
      justifyContent: 'space-around',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      zIndex: '10',
   }
   const navigateDiv = {
      position: 'absolute',
      top: '45px',
      Height: '210px',
      right: '-210px',
      width: '210px',
      height: '280px',
      transition: 'right 0.5s',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexWrap: 'wrap',
      zIndex: '1',

   }
   const navigateIconText = {
      display: 'flex',
      margin: '10px 10px'
   }
   const navigateOpenClose = () => {
      var navDiv = document.getElementById('navigateDiv');
      if (navDiv.style.right == '-210px') {
         navDiv.style.right = '0';
      } else {
         navDiv.style.right = '-210px';
      }
   }
   return (
      <>
         <button id="navigateBtn" style={NavigateBtn} onClick={navigateOpenClose} ><img style={{ width: '100%',height: '45px',borderRadius: '0' }} src="./img/final/navigate.png" atl="Navigate" /></button>
         <div id="navigateDiv" style={navigateDiv}>
            <div style={{ float: 'left',width: '75%',height: '45px',backgroundColor: '#9e9e9e',color: '#f4f4f4',display: 'flex',alignItems: 'center',justifyContent: 'center',fontSize: '18px',fontFamily: "SourceSansPro",}}>How to navigate</div><br></br>
            {/* <div style={navigateIconText}>
        <div style={{color: 'black', fontSize: '10px', margin: '32px 0 10px 0'}}>ROTATE</div><img style={{width: '64px'}} src="./img/rotate.png" alt="Rotate" />    
        </div> */}
            <div style={navigateIconText}>
               <div style={{ fontSize: '11px',color: '#808080',margin: '18px 18px 10px 10px' }}>ROTATE</div><img style={{ height: '45px' }} src="./img/final/rotate1.png" alt="Rotate" />
            </div>


            <div style={navigateIconText}>
               <div style={{ fontSize: '11px',color: '#808080',margin: '18px 18px 10px 10px' }}>ZOOM</div><img style={{ height: '46px' }} src="./img/zoom1.png" alt="Zoom" />
            </div>
            <div style={navigateIconText}>
               <div style={{ fontSize: '11px',color: '#808080',margin: '18px 18px 10px 10px' }}>MOVE</div><img style={{ height: '44px' }} src="./img/final/move1.png" alt="Move" />
            </div>
         </div>
      </>
   );
}


export default Navigate;
